import styled from "styled-components";

export const FormContainer = styled.div`
  width: 100%;
  max-width: 400px;
  margin: auto;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const FormHeader = styled.h2`
  text-align: center;
  color: #333;
`;

export const FormField = styled.div`
  margin-bottom: 15px;
  label {
    display: block;
    font-weight: bold;
    margin-bottom: 5px;
    color: #333;
  }
  input, select {
    width: 100%;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    background-color: #fff;
    box-sizing: border-box;
    
    &:focus {
      outline: none;
      border-color: #595959;
      box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.2);
    }
    
    &:disabled {
      background-color: #f5f5f5;
      color: #666;
      cursor: not-allowed;
    }
  }
  
  select {
    cursor: pointer;
    appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 8px center;
    background-size: 16px;
    padding-right: 32px;
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  padding: 10px;
  background: #595959;
  color: white;
  border: none;
  cursor: pointer;
`;

export const Message = styled.p`
  text-align: center;
  color: ${({ isError }) => (isError ? "#1a1a1a" : "#595959")};
`;
